
import { defineComponent , onMounted , } from 'vue'
import { mapGetters , mapState } from "vuex";
import { useRouter } from "vue-router";
import VDropdown from '../../base/dropdown/VDropdown.vue'
import VButton from '../../base/button/VButton.vue'
import VAvatar from '../../base/avatar/VAvatar.vue'

const router = useRouter()
import useNotyf from '../../../composable/useNotyf'
import store , { State , ActionTypes } from '../../../store'

const notif = useNotyf()

export default defineComponent( {
  name : 'UserProfileDropdown' ,
  components :
      {
        VDropdown ,
        VAvatar ,
        VButton
      } ,

  computed : {
    ... mapState( [ 'user' ] ) ,
    ... mapGetters( [ 'resetUser' ] )
  } ,
  methods : {
    logout : function () {
      store.dispatch( ActionTypes.REMOVE_USER_DATA );
      notif.success( 'See you later!' )
      this.$router.push( { path : '/login' } )
    }

  } ,
  created() {
    store.dispatch( ActionTypes.FETCH_CURRENT_USER ).catch( err => {
    } )
  }

} )

